import { render, staticRenderFns } from "./optional-btn.vue?vue&type=template&id=239c81d4&scoped=true&"
import script from "./optional-btn.vue?vue&type=script&lang=ts&"
export * from "./optional-btn.vue?vue&type=script&lang=ts&"
import style0 from "./optional-btn.vue?vue&type=style&index=0&id=239c81d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c81d4",
  null
  
)

export default component.exports